<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="addSysDict" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="编码" prop="SysDict.code">
            <el-input class="input-item" v-model="formData.SysDict.code"
              :clearable="true" placeholder="编码" type="textarea" autosize
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="名称" prop="SysDict.name">
            <el-input class="input-item" v-model="formData.SysDict.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="SysDict.content">
            <el-input class="input-item" v-model="formData.SysDict.content"
              :clearable="true" placeholder="内容"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="SysDict.remark">
            <el-input class="input-item" v-model="formData.SysDict.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="启用" prop="SysDict.enableFlag">
            <el-radio-group class="input-item" v-model="formData.SysDict.enableFlag"
              @change="onEnableFlagValueChange"
            >
              <el-radio v-for="item in addSysDict.enableFlag.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图标" prop="SysDict.icon">
            <el-input class="input-item" v-model="formData.SysDict.icon"
              :clearable="true" placeholder="图标"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="SysDict.sort">
            <el-input-number class="input-item" v-model="formData.SysDict.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('AddSysDict:addSysDict:add')"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { DictionaryController, SysDictController } from '@/api';

export default {
  name: 'AddSysDict',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    pid: {
      default: undefined
    },
    type: {
      default: undefined
    },
    gcode: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SysDict: {
          id: undefined,
          pid: this.pid,
          type: this.type,
          code: undefined,
          name: undefined,
          content: undefined,
          enableFlag: 'Y',
          remark: undefined,
          sort: 1,
          icon: undefined,
          gcode: this.gcode,
          tid: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'SysDict.code': [
          {required: true, message: '请输入编码', trigger: 'blur'}
        ],
        'SysDict.type': [
          {required: true, message: '请输入类型', trigger: 'blur'}
        ],
        'SysDict.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        'SysDict.sort': [
          {type: 'integer', message: '排序只允许输入整数', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'SysDict.content': [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],
        'SysDict.enableFlag': [
          {type: 'string', pattern: rules.pattern.english, message: '启用只允许输入英文字符', trigger: 'blur'}
        ]
      },
      addSysDict: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        enableFlag: {
          impl: new DropdownWidget(this.loadEnableFlagDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictType(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 启用下拉数据获取函数
     */
    loadEnableFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 启用选中值改变
     */
    onEnableFlagValueChange (value) {
    },
    /**
     * 更新添加字典
     */
    refreshAddSysDict (reloadData = false) {
      if (!this.addSysDict.isInit) {
        // 初始化下拉数据
        this.addSysDict.enableFlag.impl.onVisibleChange(true).catch(e => {});
      }
      this.addSysDict.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.addSysDict.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            typeDictMap: findItemFromList(this.addSysDict.type.impl.dropdownList, this.formData.SysDict.type, 'id'),
            enableFlagDictMap: findItemFromList(this.addSysDict.enableFlag.impl.dropdownList, this.formData.SysDict.enableFlag, 'id'),
            ...this.formData.SysDict
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          sysDictDto: {
            enableFlag: this.formData.SysDict.enableFlag,
            pid: this.pid,
            type: this.formData.SysDict.type,
            code: this.formData.SysDict.code,
            name: this.formData.SysDict.name,
            content: this.formData.SysDict.content,
            remark: this.formData.SysDict.remark,
            sort: this.formData.SysDict.sort,
            icon: this.formData.SysDict.icon,
            gcode: this.formData.SysDict.gcode,
            tid: this.formData.SysDict.tid
          }
        };

        SysDictController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysDict: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          name: undefined,
          content: undefined,
          enableFlag: undefined,
          remark: undefined,
          sort: undefined,
          icon: undefined,
          gcode: undefined,
          tid: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAddSysDict();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SysDict = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
